import { type Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';

const DAYS_28_MS = 28 * 24 * 60 * 60 * 1000;

export const conversationIsExpired = (conversation?: Conversation): boolean => {
	if (!conversation) {
		return false;
	}

	return conversation.channelStatus === 'EXPIRED';
};

export const conversationIsEnded = (conversation?: Conversation): boolean => {
	if (!conversation) {
		return false;
	}

	return conversation.channelStatus === 'ENDED';
};

export const conversationIsEndedOrEscalated = (conversation?: Conversation): boolean => {
	if (!conversation) {
		return false;
	}

	return conversation.channelStatus === 'ENDED' || conversation.channelStatus === 'ESCALATED';
};

export const conversationIsOld = (conversation?: Conversation): boolean => {
	if (!conversation) {
		return false;
	}
	const startMs = new Date(conversation.timeCreated).getTime();
	const nowMs = Date.now();
	const diff = nowMs - startMs;
	return diff > DAYS_28_MS;
};
